import { render, staticRenderFns } from "./Demorpt.vue?vue&type=template&id=6964e5a1&scoped=true&"
import script from "./Demorpt.vue?vue&type=script&lang=js&"
export * from "./Demorpt.vue?vue&type=script&lang=js&"
import style0 from "./Demorpt.vue?vue&type=style&index=0&id=6964e5a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6964e5a1",
  null
  
)

export default component.exports